import { Utils } from "@modules/utils";
import { Instance, applyPatch, types } from "mobx-state-tree";
import { LANGUAGE_KEY_REG_EXP } from "@constants/regexp";

export const TranslateEntity = types
  .model({
    context: types.maybeNull(types.string),
    id: types.identifierNumber,
    key: types.string,
    segment: types.string,
    translations: types.model({
      ar: types.string,
      en: types.string,
    }),
  })
  .named("TranslateEntity")
  .views((self) => ({
    get hash(): string {
      return Utils.hash({ id: self.id });
    },
  }))
  .actions((self) => ({
    setContext: (text: string): void => {
      applyPatch(self, [{ op: "replace", path: "/context", value: text }]);
    },

    setKey: (text: string): void => {
      applyPatch(self, [{ op: "replace", path: "/key", value: text }]);
    },

    setLibrary: (text: string): void => {
      applyPatch(self, [{ op: "replace", path: "/segment", value: text }]);
    },

    setTranslation: (locale: string, text: string): void => {
      applyPatch(self, [
        {
          op: "replace",
          path: `/translations/${locale}`,
          value: text,
        },
      ]);
    },

    validate: (): void => {
      /** Validate translation key format */
      if (!LANGUAGE_KEY_REG_EXP.test(self.key)) {
        throw new Error("txt_translate_key_validation");
      }
    },
  }));

export type ITranslateEntity = Instance<typeof TranslateEntity>;
